import { Category } from '../../py-generated/datalouder/stock/types';
import { Region } from '../../shared/types';

export const stockTypeToCategory = (stockType: string): Category => {
  switch (stockType.toUpperCase()) {
    case 'HK': {
      return 'HK';
    }
    case 'US':
    case 'OTC': {
      return 'US';
    }
    case 'CRYPTO': {
      return 'CRPT';
    }
    case 'CRPTBN': {
      return 'CRPTBN';
    }
    default: {
      throw new Error(`Unknown stock type ${stockType}`);
    }
  }
};

export const regionToCategory = (region: Region): Category => {
  switch (region) {
    case 'hk': {
      return 'HK';
    }
    case 'us': {
      return 'US';
    }
    default: {
      throw new Error(`Unknown region ${region}`);
    }
  }
};

export const categoryToRegin = (category: Category): Region => {
  if (category === 'CRPT') {
    return 'us';
  } else if (category == 'HK') {
    return 'hk';
  } else {
    return 'us';
  }
};
